// extracted by mini-css-extract-plugin
module.exports = {"supportive-messages-block":"MessageCarouselBlock_supportive-messages-block__1EBu4","heading":"MessageCarouselBlock_heading__1-ASF","button":"MessageCarouselBlock_button__14jm0"};